import React from "react";
import Team from "../components/site/Team";
import PageShell from "./PageShell";

export default function TeamPage() {
  return (
    <PageShell testid="team-page">
      <Team />
    </PageShell>
  );
}
